import { create } from "zustand";

interface AppState {
  // Current child profile selection
  selectedChildId: string | null;
  setSelectedChildId: (id: string | null) => void;

  // Audio preferences
  isMuted: boolean;
  toggleMute: () => void;

  // Loading states
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  // Child profile
  selectedChildId: null,
  setSelectedChildId: (id) => set({ selectedChildId: id }),

  // Audio
  isMuted: false,
  toggleMute: () => set((state) => ({ isMuted: !state.isMuted })),

  // Loading
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),
}));
